import { TableLastUpdatedSkeleton } from '@/shared/data-table/components/table-skeleton'

import { GridSkeleton } from '@/components/skeletons/grid-skeleton'
import { Skeleton } from '@/components/ui/skeleton'

export const GraylogDashboardSkeleton = () => {
	return (
		<>
			<AlertsFiltersSkeleton />

			<GridSkeleton
				length={6}
				className="grid w-full grid-cols-1 gap-2 sm:grid-cols-2 md:grid-cols-3"
				cardClassName="min-h-52"
			/>
		</>
	)
}

export const AlertsFiltersSkeleton = () => {
	return (
		<div className="mb-4 flex w-full flex-col items-end justify-between gap-4 sm:flex-row">
			<div className="flex w-full flex-col items-center justify-start gap-2 sm:flex-row">
				<div className="flex w-full flex-col gap-1 sm:w-auto">
					<p className="text-sm font-medium">Limit of entries</p>
					<Skeleton className="h-8 w-50" />
				</div>

				<div className="flex w-full flex-col gap-1 sm:w-auto">
					<p className="text-sm font-medium">Period</p>
					<Skeleton className="h-8 w-50" />
				</div>
			</div>

			<TableLastUpdatedSkeleton />
		</div>
	)
}
